import * as React from 'react';
import { ProductDetailFeatures } from '../../../../PrimaryProductInfo/ProductDetailFeatures/ProductDetailFeatures.js';
import { useSunglassesProductData } from '../../../../../context/product-context-hooks.js';

const SunglassesProductFeatures = ()=>{
    const { activeVariant: { productFeatures  } ,  } = useSunglassesProductData();
    if (!productFeatures.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailFeatures, {
        productFeatures: productFeatures
    });
};

export { SunglassesProductFeatures };
//# sourceMappingURL=SunglassesProductFeatures.js.map
